import { PrimaryButton } from "@etiquette-ui/buttons";
import styled from "styled-components";
import { PRIMARY, SECONDARY, PRIMARY_DARK, DISABLED_BUTTON, TEXT_PLACEHOLDER } from "@etiquette-ui/colors";

const FloatingButton = styled(PrimaryButton)`
  width: 45%;

  button {
    height: 48px;

    background-color: ${({isSecondary, disabled}) => !!isSecondary ? SECONDARY : !!disabled ? DISABLED_BUTTON : PRIMARY};
    color: ${({isSecondary, disabled}) => !!isSecondary ? PRIMARY : !!disabled ? TEXT_PLACEHOLDER : 'white'};

    &:hover {
      background-color: ${({isSecondary, disabled}) => !!isSecondary ? PRIMARY : !!disabled ? '#6969693D' : PRIMARY_DARK};
    }
  }

  @media( min-width: 768px ){
    width: 30%;
    min-width: 150px;
    max-width: 280px;
  }
`;

export default FloatingButton;